import React, { useEffect } from "react";
import { Image, Row, Button, Form, Input, notification, Card, Divider } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../assets/logo_ct7.png";
import adminService from "../../service/adminService";
import { updateAdminProfile } from "../../features/adminAuthenRedux/adminAuthen";
import { linkForgotPassword } from "../../constants/utils";
import "./login.css";

export default function Login() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const adminAuthen = useSelector((state) => state.adminAuthen);

  useEffect(() => {
    if (adminAuthen.user != null && adminAuthen.tokenData != null) {
      navigate("/management");
    }
  }, [adminAuthen, navigate]);

  const onFinish = async (values) => {
    const data = {
      email: values.email,
      password: values.password,
    };

    try {
      const res = await adminService.AuthService.login(data);
      if (res) {
        dispatch(updateAdminProfile(res));
        notification.success({ message: "Đăng nhập thành công!" });
        navigate("/management");
      }
    } catch (err) {
      notification.error({
        message: "Đăng nhập thất bại",
        description: err.response?.data?.message || "Có lỗi xảy ra, vui lòng thử lại!",
      });
    }
  };

  return (
    <div className="login-container">
      {/* 1. Lớp Ảnh Background Mờ nằm chìm phía dưới */}
      <div className="login-bg-layer" />

      {/* 2. Lớp phủ Màu Gradient Xanh Tối tạo chiều sâu */}
      <div className="login-overlay-layer" />

      {/* 3. Panel Login chính nằm nổi phía trên */}
      <Card className="panel-login-card">
        <Row justify="center" align="middle" style={{ flexDirection: "column" }}>
          <Image
            src={Logo}
            preview={false}
            style={{ width: 160, objectFit: "contain" }}
            alt="CT7 Logo"
          />

          <Divider
            style={{
              borderColor: "#0284c7",
              borderWidth: 2,
              margin: "20px 0 24px 0",
            }}
          />

          <Form
            form={form}
            name="basic"
            autoComplete="off"
            size="large"
            layout="vertical"
            className="formLogin"
            onFinish={onFinish}
          >
            <Form.Item
              label={<span style={{ fontWeight: 600, color: "#334155" }}>Email</span>}
              name="email"
              rules={[
                { required: true, message: "Vui lòng nhập Email!" },
                { type: "email", message: "Email không đúng định dạng!" },
              ]}
            >
              <Input placeholder="admin@ct7solutions.com" />
            </Form.Item>

            <Form.Item
              label={<span style={{ fontWeight: 600, color: "#334155" }}>Mật khẩu</span>}
              name="password"
              rules={[{ required: true, message: "Vui lòng nhập mật khẩu!" }]}
            >
              <Input.Password placeholder="••••••••" />
            </Form.Item>

            <Row justify="end" style={{ marginBottom: 20 }}>
              <Button
                type="link"
                href={linkForgotPassword()}
                style={{ padding: 0, color: "#0284c7", fontWeight: 500 }}
              >
                Quên mật khẩu?
              </Button>
            </Row>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button type="primary" htmlType="submit" className="btn-login">
                Đăng nhập
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </Card>
    </div>
  );
}